export const hasYsvLiveAccess = (status) =>
  status?.can_watch_ysvlive === true;
